import React, { useEffect, useState } from "react";

import { Button, Drawer } from "antd";
import type { DrawerProps } from "antd";
import { DataLists } from "../dataLists/DataLists";
import { dataListsType } from "./featured-posts";
import { Link } from "react-router-dom";

const SearchBar: React.FC = () => {
  const [open, setOpen] = useState(false);
  const [size, setSize] = useState<DrawerProps["size"]>();

  const [searchValue, setSearchValue] = useState("");
  const [isShowSearchResults, setIsShowSearchResults] = useState(false);
  const [searchResults, setSearchResults] = useState<dataListsType[]>([]);
  const [popularRecommendations, setPopularRecommendations] = useState<
    dataListsType[]
  >([]);

  const [windowWidth, setWindowWidth] = useState(window.innerWidth);
  useEffect(() => {
    const handleResize = () => setWindowWidth(window.innerWidth);
    window.addEventListener("resize", handleResize);

    return () => window.removeEventListener("resize", handleResize);
  }, []);

  const showDefaultDrawer = () => {
    setSize("default");
    setOpen(true);
  };
  const showLargeDrawer = () => {
    setSize("large");
    setOpen(true);
  };
  const onClose = () => {
    setOpen(false);
    setTimeout(() => {
      setSearchValue("");
      setIsShowSearchResults(false);
    }, 1000);
  };

  const getPopularRecommendations = () => {
    const allData = [...DataLists];
    const randomData = allData.sort(() => 0.5 - Math.random());
    setPopularRecommendations(randomData.slice(0, 6));
  };
  useEffect(() => {
    getPopularRecommendations();
  }, []);

  const handleSearchChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const inputValue = e.target.value;
    setSearchValue(inputValue);

    if (inputValue.trim() === "") {
      setIsShowSearchResults(false);
      setSearchResults([]);
    } else {
      setIsShowSearchResults(true);
      const filteredResults = DataLists.filter(
        (item) =>
          item.category.toLowerCase().includes(inputValue.toLowerCase()) ||
          item.tags.some((tag) =>
            tag.toLowerCase().includes(inputValue.toLowerCase())
          ) ||
          item.nation.toLowerCase().includes(inputValue.toLowerCase())
      );
      setSearchResults(filteredResults);
    }
  };

  return (
    <>
      <Button
        type="text"
        onClick={windowWidth > 800 ? showLargeDrawer : showDefaultDrawer}
        className="flex items-center"
      >
        <img
          src="icon/search.png"
          alt="searchBtn"
          className={`${windowWidth > 800 ? "w-5 h-5" : "w-5 h-5"}`}
        />
        <span
          className={`font-semibold text-[#5c687a] ${
            windowWidth > 800 ? "text-base" : "text-base"
          }`}
        >
          Search
        </span>
      </Button>

      <Drawer
        title=""
        placement="left"
        size={size}
        onClose={onClose}
        open={open}
      >
        <div className="w-full flex flex-col px-8">
          <div className="flex flex-col items-center w-full max-w-[888px]">
            <span className="text-[#e8e8e9] text-7xl font-medium pt-6">
              SEARCH
            </span>
            <div className="flex justify-between items-center w-full mb-8 border-b-2 border-[#9ba2ac]">
              <input
                type="text"
                placeholder="Search destinations,activities and eat"
                className="w-full p-3 font-medium outline-none placeholder:text-[#d9d7d7] placeholder:text-base"
                value={searchValue}
                onChange={handleSearchChange}
              />
              <div className="w-[18px] h-[18px] mr-3 flex-shrink-0">
                <img src="icon/search2.png" alt="search" />
              </div>
            </div>
          </div>
          {isShowSearchResults ? (
            // 顯示搜索結果
            <div className="flex flex-col mb-8">
              <span className="text-[#5c687a] text-xl font-semibold">
                Search Results for:
              </span>
              {searchResults.length > 0 ? (
                <ul className="flex flex-wrap gap-5 mt-3">
                  {searchResults.map((item) => {
                    return (
                      <Link
                        rel="stylesheet"
                        target="_top"
                        to={{
                          pathname: `/detailspage`,
                          search: `?id=${item.id}&${item.category}/${item.urlinform}/`,
                        }}
                        key={item.id}
                      >
                        <li className="w-[104px] h-[104px] rounded-full overflow-hidden shadow-md border-[1px] cursor-pointer">
                          <img
                            src={item.images[0]}
                            alt={item.title}
                            className="w-full h-full object-cover rounded-full"
                          />
                        </li>
                      </Link>
                    );
                  })}
                </ul>
              ) : (
                <p className="text-[#9ba2ac] text-base mt-3">
                  No results found...
                </p>
              )}
            </div>
          ) : (
            // 顯示推薦結果
            <div className="flex flex-col mt-0">
              <div className="flex flex-col mb-6">
                <p className="text-[#5c687a] text-xl font-semibold">
                  Suggested keywords:
                </p>
                <div className="mt-2 py-1 gap-2 flex flex-wrap">
                  {[
                    "Travel",
                    "Guides",
                    "Food",
                    "Hotels",
                    "China",
                    "Japan",
                    "Indonesia",
                  ].map((item) => (
                    <span
                      key={item}
                      className="py-1.5 px-3 bg-[#eeeeef] rounded-full text-sm font-medium text-[#5c687a] hover:text-[#5b68d3] cursor-pointer"
                      onClick={() => {
                        setSearchValue(item);
                        setIsShowSearchResults(true);
                        handleSearchChange({
                          target: { value: item },
                        } as React.ChangeEvent<HTMLInputElement>);
                      }}
                    >
                      {item}
                    </span>
                  ))}
                </div>
              </div>
              <span className="text-[#5c687a] text-xl font-semibold">
                Popular Recommendations:
              </span>
              <ul className="flex flex-wrap gap-5 mt-3">
                {popularRecommendations.map((item) => {
                  return (
                    <Link
                      rel="stylesheet"
                      target="_top"
                      to={{
                        pathname: `/detailspage`,
                        search: `?id=${item.id}&${item.category}/${item.urlinform}/`,
                      }}
                      key={item.id}
                    >
                      <li className="w-[104px] h-[104px] rounded-full overflow-hidden shadow-md border-[1px] cursor-pointer">
                        <img
                          src={item.images[0]}
                          alt={item.title}
                          className="w-full h-full object-cover rounded-full"
                        />
                      </li>
                    </Link>
                  );
                })}
              </ul>
            </div>
          )}
        </div>
      </Drawer>
    </>
  );
};

export default SearchBar;
